import { render, staticRenderFns } from "./aeCustomsInventory.vue?vue&type=template&id=6b490fc7&scoped=true&"
import script from "./aeCustomsInventory.vue?vue&type=script&lang=js&"
export * from "./aeCustomsInventory.vue?vue&type=script&lang=js&"
import style0 from "./aeCustomsInventory.vue?vue&type=style&index=0&id=6b490fc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b490fc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b490fc7')) {
      api.createRecord('6b490fc7', component.options)
    } else {
      api.reload('6b490fc7', component.options)
    }
    module.hot.accept("./aeCustomsInventory.vue?vue&type=template&id=6b490fc7&scoped=true&", function () {
      api.rerender('6b490fc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/aeCustomsInventory.vue"
export default component.exports